
import { VueModule } from '@Foundation/utilities';
import DataPush from './code/Scripts/components/data-push';

export default VueModule({
  components: {
    DataPush
  }
});
